import React, { Component } from 'react';
import { Button, Checkbox, Icon } from '@salesforce/design-system-react';

import { CONFERENCE_NAME } from '../../constants';
import {sessions} from '../../data';
import BrowserContainer from '../../containers/browserContainer';

class Session extends Component { 
  renderColors() {
    if(!this.props.session.workshop) {
      return (
        <span className='df df-vert-center'>
          <span className='dib session-capacity border-gray-thick bg-track2' />
          {this.props.accessible ? <span className='mls dib f4 text-track2 bold'>General</span> : null}
        </span>
      )
    } else {
      return (
        <span className='df df-vert-center '>
          <span className='dib session-capacity border-gray-thick bg-track1' />
          {this.props.accessible ? <span className='mls dib f4 text-track1 bold'>Workshop</span> : null}
        </span>
      )
    }
  }

  render() { 
    const session = this.props.session;
    return (
      <div className='mlm'> 
        <p>
          <span className='mrs caps'>Breakout</span>
          <Icon
            assistiveText={{ label: 'Date & Time' }}
            category='utility'
            className='mrs'
            name='clock'
            size='small'
            title='Date & Time'
          />
          <span>45 minutes</span>
        </p>
        <p className='df df-vert-center f3 pvxs bold'>
          {session.title}
        </p> 
        <p className='pbs measure'>{session.blurb}</p>
        <dl className='slds-list_horizontal slds-wrap'>
          <dt className='slds-item_label ptxs bold'>Speaker:</dt>
          <dl className='slds-item_detail ptxs pll'>{session.speaker}</dl>
          <dt className='slds-item_label ptxs bold'>Location:</dt>
          <dl className='slds-item_detail ptxs pll'>{session.location}</dl>
          <dt className='slds-item_label ptxs bold'>Track:</dt>
          <dl className='slds-item_detail ptxs pll'>{this.renderColors()}</dl>
        </dl>
      </div>
    )
  }
};

class SessionSelectorScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      selection: []
    }
  }

  renderAlert() {
    return (
      <div className='mbm slds-notify slds-notify_alert slds-theme_alert-texture slds-theme_error' role='alert'>
        <h2 className='f4 measure'>
          Sign up for at least two workshops!
        </h2>
        <div className='slds-notify__close'>
          <Button
            assistiveText={{ label: 'close' }}
            iconCategory='utility'
            className='mrs'
            iconName='close'
            iconSize='small'
            inverse
            variant='icon'
          />
        </div>
      </div>
    )
  }

  handleCheckboxOnchange = (session) => { 
    return () => {
      this.setState({ selection: [...this.state.selection, session]})
    }
  }

  handleRegisterOnclick = () => {
    this.props.nextFunc();
    let workshops = [];
    for(let session of this.state.selection) {
      if (session.workshop) workshops.push(session); 
    }
    console.log(workshops, this.state.selection);
    const correctSelection = workshops.length >= 2;
    if(!correctSelection) {
      this.setState((prevState, props) => ({
        error: true
      }));
    }
  }

  render() {
    return (
      <BrowserContainer currentScreenIndex={this.props.currentScreenIndex} label={`Sessions at ${CONFERENCE_NAME}`}>
        <section className='mbl slds-box mas session bg-white'>
          {this.state.error ? this.renderAlert() : null}
          <div className='pam df df-between bg-darkTeal text-white'>
            <h2 className='f3'>
              Thursday Sessions
            </h2>
            <Button
              className=''
              disabled={this.props.nextDisabled}
              iconCategory='action'
              iconName='log_event'
              iconPosition='left'
              label='Sign up'
              onClick={this.handleRegisterOnclick}
              variant='neutral'
            />
          </div>
          <ul className='mas'>
            {sessions.map((session, i) => { return (
            <li className='df pvm border-b-gray session' key={`session-${i}`}>
              <Checkbox
                assistiveText={{ label: session.title, }}
                labels={{ label: '', }}
                onChange={this.handleCheckboxOnchange(session)}
              />
              <Session
                accessible={this.props.accessible}
                currentScreenIndex={this.props.currentScreenIndex}
                nextFunc={this.props.nextFunc}
                nextDisabled={this.props.nextDisabled}
                session={session}
              />
            </li>
            )})}
          </ul>
        </section>

      </BrowserContainer>
      );
} 
}

export default SessionSelectorScreen;




// WEBPACK FOOTER //
// ./src/steps/color/sessionSelectorScreen.js